import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import { useCallback, useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import SharedTable from '../benefitPlan/SharedTable';
import debounce from 'lodash.debounce';
import Select from 'react-select';
import { fetchGetDocuments, fetchOpensearchGetAggs } from '../../utils/apiUtils.js';
import CallSummaryChart from './CallSummaryChart.jsx';
import { exportToCsv } from '../../utils/downloadUtils.js';
import DatePicker from "react-datepicker";

const INDEX = 'call-summary'
const OpensearchKnowledgebaseCallSumary = () => {

    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState()
    const [selectedCallerType, setSelectedCallerType] = useState(null)
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [selectedSubCategory, setSelectedSubCategory] = useState(null)
    const [showChart, setShowChart] = useState(false)
    const [isDownloading, setIsDownloading] = useState(false);
    const [downloadingError, setDownloadingError] = useState('')
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [showMoreColumns, setShowMoreColumns] = useState(false);

    const { ref, inView } = useInView()
    const SIZE = 10

    // const { data: categoryOptionsDep } = useQuery({
    //     queryKey: ['getAggs', 'category'],
    //     queryFn: async () => {

    //         return await fetchOpensearchGetAggs({
    //             index: INDEX,
    //             field: 'metadata.category',
    //             size: 100
    //         })
    //     },
    //     select: (data) => {
    //         const total = data.aggregations['metadata.category']?.buckets.reduce((accumulator, currentValue) => accumulator + currentValue?.doc_count, 0);
    //         return data.aggregations['metadata.category']?.buckets.map(bucket => ({
    //             label: `${bucket.key} ( ${((bucket.doc_count / total) * 100)?.toFixed(2)}% | ${bucket.doc_count} ) `,
    //             value: bucket.key,
    //             additional: bucket
    //         }))
    //     }
    // })

    // const { data: subCategoriesOptionsDep, isLoading: subCategoriesIsLoading } = useQuery({
    //     queryKey: ['getAggs', selectedCategory],
    //     queryFn: async () => {

    //         return await fetchOpensearchGetAggs({
    //             index: INDEX,
    //             field: 'metadata.subCategory',
    //             size: 10000,
    //             query: {
    //                 "term": {
    //                     "metadata.category": selectedCategory.value
    //                 }
    //             }
    //         })

    //     },
    //     select: (data) => {
    //         const total = data.aggregations['metadata.subCategory']?.buckets.reduce((accumulator, currentValue) => accumulator + currentValue?.doc_count, 0);

    //         return data.aggregations['metadata.subCategory']?.buckets.map(bucket => ({
    //             label: `${bucket.key} ( ${((bucket.doc_count / total) * 100)?.toFixed(2)}% | ${bucket.doc_count} ) `,
    //             value: bucket.key,
    //             additional: bucket
    //         }))
    //     },
    //     enabled: !!selectedCategory
    // })

    const queryKey = ['fetchKnowledgebaseDatas', decouncedSearchValue, selectedCategory, selectedSubCategory, selectedCallerType, startDate, endDate]

    let query = {
        "match_all": {}
    };

    if (decouncedSearchValue) {
        query = {
            bool: {
                must: [
                    {
                        wildcard: {
                            text: {
                                value: `*${decouncedSearchValue}*`,
                                "case_insensitive": true
                            }
                        }
                    }
                    // {
                    //     match_phrase: {
                    //         text: {
                    //             query: decouncedSearchValue,
                    //             slop: 0
                    //         }
                    //     }
                    // }
                ]
            }
        }
    }

    if (selectedCategory) {
        if (query.bool) {
            query.bool.must.push({
                term: {
                    'metadata.category': selectedCategory.value
                }
            })
        } else {
            query = {
                bool: {
                    must: [
                        {
                            term: {
                                'metadata.category': selectedCategory.value
                            }
                        }
                    ]
                }
            }
        }


        if (selectedSubCategory) {
            query.bool.must.push({
                term: {
                    'metadata.subCategory': selectedSubCategory.value
                }
            })
        }
    }

    if (selectedCallerType) {
        if (query.bool) {
            query.bool.must.push({
                term: {
                    'metadata.callerType': selectedCallerType.value
                }
            })
        } else {
            query = {
                bool: {
                    must: [
                        {
                            term: {
                                'metadata.callerType': selectedCallerType.value
                            }
                        }
                    ]
                }
            }
        }
    }
    if (startDate && endDate && startDate?.toString() !== "Invalid Date" && endDate?.toString() !== "Invalid Date") {
        console.log({ startDate, endDate })
        const startYear = startDate.getUTCFullYear()
        const endYear = endDate.getUTCFullYear();

        const startMonth = String(startDate.getUTCMonth() + 1).padStart(2, '0');
        const endMonth = String(endDate.getUTCMonth() + 1).padStart(2, '0');

        const startUtcDate = String(startDate.getUTCDate()).padStart(2, '0');
        const endUtcDate = String(endDate.getUTCDate()).padStart(2, '0');

        query = {
            bool: {
                ...query?.bool,
                filter: {
                    "script": {
                        "script": {
                            "source": `def dateStr = doc['metadata.year'].value + '-' + doc['metadata.month'].value + '-' + doc['metadata.day'].value;
LocalDate date = LocalDate.parse(dateStr);
LocalDate start = LocalDate.parse(params.start);
LocalDate end = LocalDate.parse(params.end);

// !isBefore means "is after or equal to"
// !isAfter means "is before or equal to"
return !date.isBefore(start) && !date.isAfter(end);`,
                            "params": {
                                "start": `${startYear}-${startMonth}-${startUtcDate}`,
                                "end": `${endYear}-${endMonth}-${endUtcDate}`,
                            }
                        }
                    }
                }
                // query.bool.must.push({
                //     range: {
                //         'metadata.year': {
                //             gte: startYear,
                //             lte: endYear
                //         }
                //     }
                // })
            }
        }

    }

    const {
        data,
        error,
        isError,
        fetchNextPage,
        hasNextPage,
        isLoading,
        isFetching,
        isFetchingNextPage,
        status,

    } = useInfiniteQuery(
        {
            queryKey,
            queryFn: async ({ pageParam }) => {


                let body = {
                    index: INDEX,
                    "_source": ["text", "metadata"],
                    query,
                    size: SIZE,
                    track_total_hits: true,
                    "sort": [
                        { "metadata.year": { "order": "asc" } },
                        { "metadata.month": { "order": "asc" } },
                        { "metadata.day": { "order": "asc" } },
                        {
                            "metadata.uniqueId": {
                                "order": "asc"
                            }
                        }
                    ],
                    aggs: {
                        'agentOverallSentiment': {
                            avg: {
                                field: 'metadata.agentOverallSentiment'
                            }
                        },
                        'customerOverallSentiment': {
                            avg: {
                                field: 'metadata.customerOverallSentiment'
                            }
                        },
                        uniqueCategories: {
                            terms: {
                                field: 'metadata.category', // Bucket aggregation (terms)
                                size: 100 // Return top 10 categories
                            }
                        },
                        uniqueSubCategories: {
                            terms: {
                                field: 'metadata.subCategory', // Bucket aggregation (terms)
                                size: 100 // Return top 10 categories
                            }
                        },
                        uniqueCallerTypes: {
                            terms: {
                                field: 'metadata.callerType', // Bucket aggregation (terms)
                                size: 100 // Return top 10 categories
                            }
                        }
                    }
                }
                if (pageParam.searchAfter) {
                    body.search_after = pageParam.searchAfter
                }

                return fetchGetDocuments(body)

            },

            initialPageParam: 0,
            getNextPageParam: (lastPage, pages) => {
                //   console.log({ lastPage })
                const lastItem = lastPage.hits?.hits.at(-1)
                if (!lastItem || (lastPage.hits?.hits?.length < SIZE)) return undefined
                return { searchAfter: lastItem.sort }
            },
            // Enabled if: (Either is missing) OR (Both are present)
            enabled: (!startDate || !endDate) || (!!startDate && !!endDate),
        }
    )

    useEffect(() => {
        if (inView) {
            fetchNextPage()
        }
    }, [inView])

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    let columns = ['text', 'metadata.callReason', 'metadata.solution', 'metadata.category', 'metadata.subCategory', 'metadata.fullDate', 'metadata.callerType']


    if (showMoreColumns) {
        columns = [
            ...columns,
            'metadata.agentOverallSentiment',
            'metadata.customerOverallSentiment'

        ];
    }

    const results = data?.pages?.map(page => page.hits?.hits)?.flat()
    const uniqueCategoriesAggs = data?.pages?.map(page => page.aggregations.uniqueCategories.buckets)?.flat()
    const uniqueSubCategoriesAggs = data?.pages?.map(page => page.aggregations.uniqueSubCategories.buckets)?.flat()
    const uniqueCallerTypesAggs = data?.pages?.map(page => page.aggregations.uniqueCallerTypes.buckets)?.flat()
    const agentOverallSentiment = data?.pages?.map(page => page.aggregations.agentOverallSentiment.value)?.reduce((acc, val) => acc + val, 0) / data?.pages?.length;
    const customerOverallSentiment = data?.pages?.map(page => page.aggregations.customerOverallSentiment.value)?.reduce((acc, val) => acc + val, 0) / data?.pages?.length;
    const total = data?.pages?.[0]?.hits?.total?.value

    const colors = [
        'rgba(150, 233, 58, 0.9)',
        'rgba(231, 102, 14, 0.9)',
        'rgba(252, 49, 115, 0.9)',
        'rgba(114, 48, 235, 0.9)',
        'rgba(228, 179, 3, 0.9)',
        'rgba(33, 148, 249, 0.9)',
        'rgba(146, 7, 231, 0.9)',
        'rgba(35, 240, 141, 0.9)',
    ]

    const downloadHandler = async () => {

        setIsDownloading(true)
        setDownloadingError(null)
        let items = []
        try {
            let searchAfter

            let body = {
                index: INDEX,
                "_source": ["text", "metadata"],
                query,
                size: 100,
                track_total_hits: true,
                "sort": [
                    {
                        "metadata.uniqueId": {
                            "order": "asc"
                        }
                    }
                ]
            }

            do {

                const results = await fetchGetDocuments(body)
                const lastItem = results.hits?.hits.at(-1)

                results.hits?.hits?.map(({ _source }, i) => {
                    items.push({ text: _source.text, ..._source.metadata })
                })

                searchAfter = lastItem?.sort

                if (searchAfter) {
                    body.search_after = searchAfter
                }
            } while (searchAfter);


            let fileNamePrefix = ''
            if (selectedCategory) {
                fileNamePrefix = selectedCategory.value
                if (selectedSubCategory) {
                    fileNamePrefix += `_${selectedSubCategory.value}`
                }
            }

            if (decouncedSearchValue) {
                fileNamePrefix += `_${decouncedSearchValue}`;
            }
            exportToCsv({
                fileNamePrefix: fileNamePrefix.replaceAll(' ', '_'),
                items, //state.items,
                headers: ['text', 'category', 'subCategory', 'year', 'month', 'day', 'originalFileName'],
            });

        } catch (error) {
            setDownloadingError(error.message)
        } finally {
            setIsDownloading(false)
        }

    }

    const onChange = (dates) => {
        const [start, end] = dates;
        setSelectedCategory(null); setSelectedSubCategory(null); setSelectedCallerType(null)
        setStartDate(start);
        setEndDate(end);
    };

    const categoryOptions = uniqueCategoriesAggs?.map(bucket => ({
        label: `${bucket.key} ( ${((bucket.doc_count / total) * 100)?.toFixed(2)}% | ${bucket.doc_count} ) `,
        value: bucket.key,
        additional: bucket
    })) || []

    const subCategoriesOptions = uniqueSubCategoriesAggs?.map(bucket => ({
        label: `${bucket.key} ( ${((bucket.doc_count / total) * 100)?.toFixed(2)}% | ${bucket.doc_count} ) `,
        value: bucket.key,
        additional: bucket
    })) || []

    const uniqueCallerTypesOptions = uniqueCallerTypesAggs?.map(bucket => ({
        label: `${bucket.key} ( ${((bucket.doc_count / total) * 100)?.toFixed(2)}% | ${bucket.doc_count} ) `,
        value: bucket.key,
        additional: bucket
    })) || []



    const labels = ((selectedCategory && subCategoriesOptions) || categoryOptions)?.slice(0, 5).map(l => l.value)
    const datasets = [
        {
            label: selectedCategory?.value,
            data: ((selectedCategory && subCategoriesOptions) || categoryOptions)?.slice(0, 5).map(l => l.additional?.doc_count),
            // backgroundColor: colors.slice(0, 5),
            // borderRadius: 5

            backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
            ],
            borderWidth: 1,

        }
    ]

    return (
        <div className={'container '} style={{ padding: '1rem' }}>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>


                <div>
                    <p className='title'>OpenSearch {total && `Total: (${total})`}</p>
                    <p className="sub-title">Explore data</p>
                </div>

                {isDownloading ? <div className="loader" /> : <div >
                    <p className="clickable-link" style={{ color: 'var(--green)', padding: '0rem 1rem' }} onClick={downloadHandler}>{downloadingError ? 'Retry' : 'Download'}</p>
                    {downloadingError && <p className="danger" style={{ padding: '0rem 1rem' }}>{downloadingError}</p>}
                </div>}

            </div>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '.6rem', minWidth: 300 }}>

                        <DatePicker
                            className="date-picker"

                            selected={startDate}
                            onChange={onChange}
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange // This prop enables date range selection
                            inline={false}
                            dateFormat={'yyyy-MM-dd'} // Renders the calendar inline (optional)
                            placeholderText="Select a date range"
                        />
                        {/* <p style={{ paddingLeft: '.4rem' }}>Local: {selectedDate?.toLocaleString()}</p> */}

                    </div>




                    <Select
                        name={'CallerType'}
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        placeholder={'Filter by Caller Type'}
                        isLoading={isLoading}
                        options={uniqueCallerTypesOptions}
                        value={selectedCallerType}
                        isClearable={true}
                        onChange={(option) => { setSelectedCategory(null); setSelectedSubCategory(null); setSelectedCallerType(option) }}
                    />

                    <Select
                        name={'Category'}
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        placeholder={'Filter by Category'}
                        isLoading={isLoading}
                        options={categoryOptions}
                        value={selectedCategory}
                        isClearable={true}
                        onChange={(option) => { setSelectedSubCategory(null); setSelectedCategory(option) }}
                    />


                    {selectedCategory && <Select
                        name={'Sub category'}
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        placeholder={'Filter by sub category'}
                        isLoading={isLoading}
                        options={subCategoriesOptions}
                        value={selectedSubCategory}
                        isClearable={true}
                        onChange={(option) => { setSelectedSubCategory(option); }}
                    />}

                    <input
                        style={{ fontSize: '1rem', minWidth: '250px', margin: ' 0rem', padding: '1rem', borderRadius: '.4rem', border: '1px solid var(--lighterGrey)', outline: 'none' }}
                        type="text"
                        id={'search'}
                        placeholder="search..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />

                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0rem 1rem 1rem 0rem', }}>
                <p style={{ cursor: 'pointer', color: 'var(--red)' }}
                    onClick={() => {
                        setSelectedCategory(null)
                        setSelectedSubCategory(null)
                        setSelectedCallerType(null)
                        setSearchValue('')
                        setDecouncedSearchValue('')

                        setStartDate(null)
                        setEndDate(null)

                    }}
                >Clear filters</p>

                <div style={{ display: 'flex', gap: '1rem' }}>
                    <p style={{ cursor: "pointer", color: "var(--green)" }} onClick={() => setShowMoreColumns(!showMoreColumns)}>
                        {showMoreColumns ? "Less Columns" : "More Columns"}
                    </p>
                    {showChart ? <p style={{ padding: '0rem 0rem 1rem 0rem', color: 'var(--red)', textAlign: 'right', cursor: 'pointer' }}
                        onClick={() => setShowChart(false)}>Hide Chart</p> : <p
                            style={{ padding: '0rem 0rem 1rem 0rem', color: 'var(--green)', textAlign: 'right', cursor: 'pointer' }}
                            onClick={() => setShowChart(true)}>Show Chart</p>}


                </div>


            </div>

            {isError && <p className="danger">{error?.message}</p>}



            {showChart ?

                <div style={{ height: '500px', padding: '1rem 0rem' }}>
                    <CallSummaryChart data={{ labels, datasets }} />
                </div> : <></>

            }


            {
                status === 'loading' ? (
                    <p>Loading...</p>
                ) : status === 'error' ? (
                    <span className='danger'>Error: {error.message}</span>
                ) : (
                    <>
                        {(agentOverallSentiment && customerOverallSentiment) ? <div style={{ display: 'flex', gap: '1rem', padding: '0rem 0rem 0.6rem 0rem' }}>
                            <p>Agent Overall Sentiment: {agentOverallSentiment?.toFixed(2)}</p>
                            <p>Customer Overall Sentiment: {customerOverallSentiment?.toFixed(2)}</p>
                        </div> : <></>}

                        <SharedTable
                            type={'knowledgebase'}
                            columns={columns}
                            items={results?.map(hit => ({ _id: hit?._id, ...hit?._source }))?.map(h => ({
                                ...h,
                                metadata: {
                                    ...h.metadata,
                                    fullDate: `${h?.metadata?.year}-${h?.metadata?.month}-${h?.metadata?.day}`
                                }
                            }))}
                            activeDraftId={null}
                            hasNextPage={hasNextPage}
                            isLoading={isLoading}
                            isFetchingNextPage={isFetchingNextPage}
                            fetchNextPage={fetchNextPage}
                            isFetching={isFetching}
                            searchText={decouncedSearchValue}
                            ref={ref}
                        />
                    </>
                )
            }

        </div>
    )
}

export default OpensearchKnowledgebaseCallSumary
